import React from 'react';

import API from 'utils/api';

import { groupSelectionKey } from 'components/SharedFormComponents/UserAndGroupPicker';
import LicenceCoverageNotice, {
  LicenceNoticeSurface,
} from 'components/SharedFormComponents/UserAndGroupPicker/LicenceCoverageNotice';
import useGroupLicencePreview from 'components/SharedFormComponents/UserAndGroupPicker/useGroupLicencePreview';

interface GroupLicenceCoverageNoticeProps {
  entityId: string;
  groupUuids: string[];
  savedGroupUuids: string[];
  groupNames: string[];
}

const GroupLicenceCoverageNotice: React.FunctionComponent<GroupLicenceCoverageNoticeProps> = ({
  entityId,
  groupUuids,
  savedGroupUuids,
  groupNames,
}) => {
  const preview = useGroupLicencePreview(
    groupUuids,
    async () =>
      (await API.entities.previewDocumentPermissionLicenceCoverage('documents', entityId, { groupUuids })()).data,
    { scopeKey: entityId }
  );

  if (!preview) return null;

  return (
    <LicenceCoverageNotice
      surface={LicenceNoticeSurface.DocumentAccess}
      total={preview.total}
      licensed={preview.licensed}
      groupNames={groupNames}
      groupSelectionChanged={groupSelectionKey(groupUuids) !== groupSelectionKey(savedGroupUuids)}
      testId="group-licence-coverage-notice"
    />
  );
};

export default GroupLicenceCoverageNotice;
